export function burgerInit() {
  const $b = $('.button-burger');
  const $h = $('html');
  const showClass = 'mobile-menu-show';
  const hideClass = 'mobile-menu-hide';
  const timeout = 500;

  function hideNavigation() {
    $h.removeClass(showClass).addClass(hideClass);
    setTimeout(() => {
      $h.removeClass(hideClass);
    }, timeout);
  }

  $b.on('click', () => {
    if ($h.is('.' + showClass)) {
      hideNavigation();
    } else {
      $h.addClass(showClass);
    }
  });

  $('.mobile-menu-navigation')
    .find('ul li a')
    .on('click', () => {
      hideNavigation();
    });
}
